import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import type { JackpotVariant } from '../../types';

/**
 * JackpotHeader is a presentational component that wraps its children with a styled div.
 * It applies a set of utility classes for layout and padding, and merges any additional classes provided via the className prop.
 * It inherits HTMLDivElement.
 * @param variant - The variant of the jackpot header (default or sticky).
 * @returns The styled header wrapping the provided children.
 */
function JackpotHeader({ variant, className, ...props }: { variant: JackpotVariant } & ComponentProps<'div'>) {
  const classes = twMerge('ll-container-inner flex flex-col items-stretch gap-y-6', variant === 'sticky' && 'flex-row gap-x-10 lg:px-12.5', className);
  return <div className={classes} {...props} />;
}

export { JackpotHeader };
